import React, {useMemo} from 'react'
import {UIGameTimer} from './UIGameTimer'
import {GameValidator} from '@colonist/game-mechanic-validators'
import {tempIsGameEndDefined} from '../UIGameEnd'
import {useGameStore} from '../../store/GameStoreContext'

interface UIGameTimerContainerProps {
    timerStyle: 'white' | 'beige'
    className?: string | undefined
}

export const UIGameTimerContainer = ({
    timerStyle,
    className,
}: UIGameTimerContainerProps) => {
    const timeLeftInSeconds = useGameStore((state) => state.timeLeftInSeconds)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const gameState = useGameStore((state) => state.gameState)
    const userStates = useGameStore((state) => state.gameUserStates.userStates)
    const myColor = useGameStore((state) => state.myColor)

    const isMyPlayerTakingAction = useMemo(() => {
        const gameValidator = new GameValidator(gameState, userStates)
        const playersTakingAction = gameValidator.getPlayersTakingAction()
        return playersTakingAction.includes(myColor)
    }, [gameState, userStates, myColor])

    if(tempIsGameEndDefined) return null

    return <UIGameTimer
        className={className}
        timeLeftInSeconds={timeLeftInSeconds}
        isMyPlayerTakingAction={isMyPlayerTakingAction}
        isPaused={isPaused}
        timerStyle={timerStyle} />
}
